angular.module('workflow', ['core', 'files', 'document'])
    .factory('Workflow', function ($resource) {
        return $resource('/crm/api/workflow/:id', {id: "@id"}, {
            allGranted: {method: 'GET', isArray: false, url: '/crm/api/workflow/all-granted'},
            table: {method: 'GET', isArray: false, url: '/crm/api/workflow/table'},
            tableStatistics: {method: 'GET', isArray: false, url: '/crm/api/workflow/table-statistics'},
            pass: {method: 'PUT', url: '/crm/api/workflow/:id/pass'},
            get: {method: 'GET'},
            update: {method: 'PUT'},
            touches: {method: 'GET', isArray: true, url: '/crm/api/workflow/:id/touches'},
            deleteTouch: {method: 'DELETE', url: '/crm/api/workflow/:id/touches/:userId'},
            addTouchOnly: {method: 'POST', url: '/crm/api/workflow/:id/touches'},
            history: {method: 'GET', isArray: true, url: '/crm/api/workflow/:id/history'},
            action: {method: 'PUT', url: '/crm/api/workflow/:id/:action', params: {id: "@id", action: "@action"}},
            links: {method: 'GET', isArray: true, url: "/crm/api/workflow/:id/link"},
            thread: {method: 'GET', isArray: true, url: "/crm/api/workflow/:id/thread"},
            link: {method: 'POST', url: "/crm/api/workflow/:id/link"},
            unlink: {method: 'DELETE', url: "/crm/api/workflow/:id/link/:item", params: {item: "@item"}},
        });
    })
    .component('workflowStatusLabel', {
        bindings: {
            status: '<'
        },
        template: `
            <span class="label label-default workflow-status {{$ctrl.status}}">{{ 'workflow.status.'.concat($ctrl.status) | translate }}</span>
        `
    })
    .component('workflowDirectionIco', {
        bindings: {
            direction: '<',
            showName: '<'
        },
        template: `
            <i class="workflow-direction-icon {{$ctrl.direction}}" uib-tooltip="{{ 'workflow.direction.' + $ctrl.direction | translate }}"></i><span ng-if="$ctrl.showName">&nbsp;{{ 'workflow.direction.' + $ctrl.direction | translate }}</span>
         `
    })
    .component('workflowCategoryList', {
        bindings: {
            items: '<'
        },
        template: `
            <span class="workflow-category-list" ng-if="$ctrl.categories.length > 0">
                <span class="workflow-category-list__item" ng-repeat="category in $ctrl.categories track by category.id">
                    {{category.name}}
                </span>
            </span>
            <span class="workflow-category-list workflow-category-list--empty" ng-if="$ctrl.categories.length === 0">-</span>
        `,
        controller: function () {
            this.$onChanges = () => {
                const categories = angular.isArray(this.items) ? this.items : [];
                this.categories = categories
                    .filter(category => category != null && category.name != null)
                    .slice()
                    .sort((a, b) => a.name.localeCompare(b.name));
            }
        }
    })
    .component('workflowDeadlineBadge', {
        bindings: {
            strict: '<',
            isLate: '<',
            daysLeft: '<'
        },
        template: `
             <span
                 ng-if="$ctrl.shouldShow()"
                 class="badge badge-warning workflow-deadline-badge"
                 ng-class="{'badge-warning': !$ctrl.isDanger(), 'badge-danger': $ctrl.isDanger()}"
                 uib-tooltip="{{$ctrl.getTooltip()}}">
                    <i class="fas fa-hourglass-half"></i>&nbsp;{{$ctrl.getDisplayDays()}} d
             </span>
         `,
        controller: function () {
            this.isCloseToDeadline = () => {
                if (this.daysLeft == null) {
                    return false
                }
                return this.daysLeft >= -3 && this.daysLeft <= 0
            }
            this.isDanger = () => {
                if (this.strict !== true) {
                    return false
                }
                if (this.isLate === true) {
                    return true
                }
                return this.isCloseToDeadline()
            }
            this.getDisplayDays = () => {
                if (this.daysLeft == null) {
                    return null
                }
                if (this.isLate === true) {
                    return this.daysLeft
                }
                return Math.abs(this.daysLeft)
            }
            this.shouldShow = () => {
                if (this.daysLeft == null) {
                    return false
                }
                if (this.isLate === true) {
                    return true
                }
                return this.strict === true && this.isCloseToDeadline()
            }
            this.getTooltip = () => {
                if (this.isLate === true) {
                    if (this.daysLeft == null) {
                        return "Opóźniona"
                    }
                    return "Opóźniona " + this.daysLeft + " dni"
                }
                if (this.strict === true && this.isCloseToDeadline()) {
                    let text = "Zbliża się (w ciągu 3 dni) termin nieprzekraczalny"
                    if (this.daysLeft != null) {
                        text += ". Pozostało: " + Math.abs(this.daysLeft) + " dni"
                    }
                    return text
                }
                return "Termin nieprzekraczalny"
            }
        }
    })
    .component('workflowDeadlineFlame', {
        bindings: {
            strict: '<',
            isLate: '<',
            daysLeft: '<'
        },
        template: `
             <span
                 class="workflow-deadline-flame"
                 ng-if="$ctrl.strict === true && $ctrl.isLate !== true && !$ctrl.isCloseToDeadline()"
                 uib-tooltip="{{$ctrl.getTooltipNotLate()}}"
             >🔥&nbsp;</span>
             <span
                 class="workflow-deadline-flame workflow-deadline-flame--large blinking"
                 ng-if="$ctrl.strict === true && $ctrl.isLate !== true && $ctrl.isCloseToDeadline()"
                 uib-tooltip="{{$ctrl.getTooltipClose()}}"
             >🔥&nbsp;</span>
             <span
                 class="workflow-deadline-flame workflow-deadline-flame--large blinking"
                 ng-if="$ctrl.strict === true && $ctrl.isLate === true"
                 uib-tooltip="{{$ctrl.getTooltipLate()}}"
             >🔥&nbsp;</span>
         `,
        controller: function () {
            this.isCloseToDeadline = () => {
                if (this.daysLeft == null) {
                    return false
                }
                return this.daysLeft >= -3 && this.daysLeft <= 0
            }
            this.getTooltipNotLate = () => {
                let text = "Termin nieprzekraczalny";
                if (this.daysLeft != null) {
                    text += ". Pozostało: " + Math.abs(this.daysLeft) + " dni"
                }
                return text
            }
            this.getTooltipClose = () => {
                let text = "Zbliża się (w ciągu 3 dni) termin nieprzekraczalny";
                if (this.daysLeft != null) {
                    text += ". Pozostało: " + Math.abs(this.daysLeft) + " dni"
                }
                return text
            }
            this.getTooltipLate = () => {
                let text = "Zbliża się (w ciągu 3 dni) lub przekroczony termin nieprzekraczalny";
                if (this.daysLeft != null) {
                    text += ". Opóźniona: " + this.daysLeft + " dni"
                }
                return text
            }
        }
    })
    .service('WorkflowService', function ($state, $http, $rootScope, modals, Workflow, FilesSimpleUploadService) {
        this.statuses = () => ['PENDING', 'DISCUSSION', 'PAUSED', 'FINISHED_INTERNALLY', 'ANSWERED']
        this.isStatusFinished = status => {
            return ['ANSWERED', 'FINISHED_INTERNALLY'].includes(status)
        }
        this.getDirections = () => ['IN', 'OUT']
        this.getOppositeDirection = direction => {
            if (direction === 'IN') {
                return 'OUT'
            }
            if (direction === 'OUT') {
                return 'IN'
            }
            return null
        }
        this.add = () => $state.go('workflowAdd')
        this.addResponse = item => $state.go('workflowAdd', {responseTo: item, shortForm: false})
        this.delete = item => {
            return modals.confirmDelete(item.id, () => Workflow.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast('workflow.deleted')))
        }
        this.pass = item => {
            return modals.open('app/workflow/pass-modal.html', 'WorkflowPassController', item, {size: "sm"}, "$ctrl")
        }
        this.action = (id, action) => {
            return Workflow.action({id: id, action: action}).$promise.then(() => $rootScope.$broadcast('workflow.updated'))
        }
        this.daysLeft = item => {
            if (item == null)
                return null

            if (!item.dateOfDeadline)
                return null

            let dateFrom = new Date(item.dateOfDeadline);
            let dateTo = new Date();
            dateFrom.setHours(0, 0, 0, 0);
            dateTo.setHours(0, 0, 0, 0);

            let t2 = dateTo.getTime();
            let t1 = dateFrom.getTime();

            return Math.round((t2 - t1) / (24 * 3600 * 1000))
        }
        this.isLate = item => {
            if (item == null)
                return false

            if (!item.dateOfDeadline)
                return false

            if (this.isStatusFinished(item.status))
                return false

            let dateFrom = new Date(item.dateOfDeadline);
            let dateTo = new Date();
            dateFrom.setHours(0, 0, 0, 0);
            dateTo.setHours(0, 0, 0, 0);

            let t1 = dateTo.getTime();
            let t2 = dateFrom.getTime();

            return Math.round((t1 - t2) / (24 * 3600 * 1000)) > 0
        }
        this.isLateOnly = item => {
            if (item == null)
                return false

            if (!item.dateOfDeadline)
                return false

            let dateFrom = new Date(item.dateOfDeadline);
            let dateTo = new Date();
            dateFrom.setHours(0, 0, 0, 0);
            dateTo.setHours(0, 0, 0, 0);

            let t1 = dateTo.getTime();
            let t2 = dateFrom.getTime();

            return Math.round((t1 - t2) / (24 * 3600 * 1000)) > 0
        }
        this.createFromClassification = (classification) => {
            return $http.post('/crm/api/file-association-workflow/from-file-id', {fileId: classification.file.id, description: classification.description})
                .then(response => {
                    $state.go('workflowEdit', {id: response.data.id})
                })
        }
        this.uploadMainFile = item => {
            let filters = [{
                name: 'Filtr PDF',
                fn: function (item /*{File|FileLikeObject}*/, options) {
                    var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
                    return '|pdf|'.indexOf(type) !== -1;
                }
            }]
            return FilesSimpleUploadService.openCustom({url: `/crm/api/file-association-workflow/${item.id}/main-file`, settings: {filters: filters}}).then(() => $rootScope.$broadcast("workflow.updated"))
        }
        this.uploadFiles = () => {
            let filters = [{
                name: 'Filtr PDF',
                fn: function (item /*{File|FileLikeObject}*/, options) {
                    var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
                    return '|pdf|'.indexOf(type) !== -1;
                }
            }]
            return FilesSimpleUploadService.open({type: 'WORKFLOW', filters: filters}).then(() => $rootScope.$broadcast("workflow.updated"))
        }
        this.deleteTouch = (id, userId) => {
            return modals.confirmDelete("wybrany rekord", () => Workflow.deleteTouch({id: id, userId: userId}).$promise.then(() => $rootScope.$broadcast('workflow.updated')));
        }
        this.history = entity => {
            return modals.open('app/workflow/history-modal.html', 'WorkflowProcessingHistoryController', entity.id, {size: "lg"}, "$ctrl")
        }
        this.addTouchOnly = entity => {
            return modals.open('app/workflow/add-touch-only-modal.html', 'WorkflowAddTouchOnlyController', entity.id, {size: "md"}, "$ctrl")
        }
        this.select = (params) => {
            let data
            if (params instanceof Array) {
                data = {alreadySelectedIds: params}
            } else {
                data = angular.extend({alreadySelectedIds: []}, params || {})
            }
            return modals.open('app/workflow/select-modal.html', 'WorkflowSelectController', data, {size: "lg"}, "$ctrl");
        }
        this.link = (id, selected) => {
            return this.select(selected).then(item => {
                Workflow.link({id: id, workflowId: item.id}).$promise.then(() => $rootScope.$broadcast('workflow.updated'))
            })
        }
        this.unlink = (entityId, itemId) => {
            return Workflow.unlink({id: entityId, item: itemId}).$promise.then(() => $rootScope.$broadcast('workflow.updated'))
        }
    })
    .run(function (NavbarLeftMenu, Principal, $http, $interval, $rootScope) {
        const menuPath = '/workflow'

        function loadCounter() {
            Principal.identity().then(account => {
                let auth = Principal.hasAnyAuthority(['ROLE_WORKFLOW_MODULE'])
                if (!auth) {
                    NavbarLeftMenu.updateCount(menuPath, 0)
                    return;
                }

                $http.get("/crm/api/workflow/table?filter=my&status=PENDING&status=DISCUSSION&status=PAUSED").then(response => {
                    let statistics = response.data
                    NavbarLeftMenu.updateCount(menuPath, statistics.fullListSize)
                }).catch(() => {
                    NavbarLeftMenu.updateCount(menuPath, 0)
                })
            })
        }

        NavbarLeftMenu.add({
            authorities: "ROLE_WORKFLOW_MODULE",
            path: menuPath,
            ico: "fa fa-fw fa-briefcase",
            name: 'workflow.menu',
            order: 84
        });

        $rootScope.$on("workflow.updated", () => loadCounter())
        $rootScope.$on("authenticationChanged", () => loadCounter())

        let intPromise = null;

        function initAutoRefresh() {
            $interval.cancel(intPromise)
            loadCounter()
            intPromise = $interval(initAutoRefresh, 60000)
        }

        this.$onDestroy = () => $interval.cancel(intPromise);

        initAutoRefresh()
    })
    .config(function ($stateProvider) {
        $stateProvider.state('workflowList', {
            parent: 'app',
            url: '/workflow?{page:int}&{size:int}&sort&search&startDate&endDate&status&type&user&filter&category&communicationChannel&types&sender&recipient&project&direction&strictDeadline&strictDeadlineExpiring',
            data: {
                authorities: ['ROLE_WORKFLOW_MODULE']
            },
            params: {
                types: {array: true, type: "int", value: [], squash: false},
                status: {array: true, value: ['PENDING', 'DISCUSSION', 'PAUSED'], squash: false},
                filter: {value: 'my', squash: true},
            },
            views: {
                'content@': 'workflowList'
            },
            resolve: {
                statistics: (Workflow, $stateParams) => Workflow.tableStatistics($stateParams).$promise,
                filters: ($stateParams) => angular.copy($stateParams),
                page: (Workflow, $stateParams) => Workflow.table($stateParams).$promise
            }
        })
        $stateProvider.state('workflowEdit', {
            parent: 'app',
            url: '/workflow/{id}/edit',
            data: {
                authorities: ['ROLE_WORKFLOW_MODULE']
            },
            views: {
                'content@': {
                    templateUrl: 'app/workflow/edit.html',
                    controller: 'WorkflowEditController',
                    controllerAs: '$ctrl'
                }
            },
            resolve: {
                item: (Workflow, $stateParams) => Workflow.get({id: $stateParams.id}).$promise
            }
        })
        $stateProvider.state('workflowAdd', {
            parent: 'app',
            url: '/workflow/new',
            data: {
                authorities: ['ROLE_WORKFLOW_MODULE']
            },
            params: {
                responseTo: null,
                shortForm: true
            },
            views: {
                'content@': {
                    templateUrl: 'app/workflow/edit.html',
                    controller: 'WorkflowEditController',
                    controllerAs: '$ctrl'
                }
            },
            resolve: {
                item: ($stateParams, WorkflowService) => ({
                    status: 'PENDING',
                    responseToOther: $stateParams.responseTo ? true : false,
                    responseTo: $stateParams.responseTo || null,
                    direction: $stateParams.responseTo ? WorkflowService.getOppositeDirection($stateParams.responseTo.direction) : null,
                    sender: $stateParams.responseTo ? $stateParams.responseTo.recipient : null,
                    recipient: $stateParams.responseTo ? $stateParams.responseTo.sender : null,
                    shortForm: $stateParams.shortForm !== false
                })
            }
        })
        $stateProvider.state('workflowShowFull', {
            parent: 'app',
            url: '/workflow/{id}',
            data: {
                authorities: ['ROLE_WORKFLOW_MODULE']
            },
            views: {
                'content@': {
                    templateUrl: 'app/workflow/show.html',
                    controller: 'WorkflowShowFullController',
                    controllerAs: '$ctrl'
                }
            },
        })
    })
